import styled from "styled-components";
import { Link } from "./link";

export const Container = styled.a`
  background-color: #EB5A00;
  border: 0 none;
  border-radius: 500px;
  box-shadow: 0px 0px 24px 0px #EB5A009E;
  color: #FFFFFF;
  padding: 10px 32px;
  white-space: nowrap;
  width: 100%;

  &:hover {
    background-color: #FF6200;
    box-shadow: 0px 0px 24px 0px #FF62009E;
  }
`

export const LinkEmpty = styled(Link)`
  background-color: transparent;
  border: 1px solid #FFFFFF;
  border-radius: 40px;
  box-shadow: none;
  color: #FFFFFF;
  font-size: 24px;
  font-weight: 700;
  line-height: 27.58px;
  padding: 8px 77px;
  text-align: center;

  &:hover {
    background-color: #FFFFFF40;
    box-shadow: none;
  }
`